import React from 'react';
import { Space, Breadcrumb } from 'antd';
import { CardLayout, B2BTable } from 'components/molecules';
import SearchBox from './SearchBox'
import { useProjectConsult } from 'hooks';

export interface  ProjectConsultProps {}

const  ProjectConsult = ({}:  ProjectConsultProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */

  const { projectList, searchResult, refetch } = useProjectConsult();  
 

  /* ======================================================
   * variables
   * ====================================================== */
  
  /* ======================================================
   * events
   * ====================================================== */    
 
  /* ======================================================
   * hooks
   * ====================================================== */
 
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2B</Breadcrumb.Item>
        <Breadcrumb.Item>논의중</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <B2BTable 
              pType='consult'
              projectList={projectList} 
              searchResult={searchResult} 
              hiddenColumns={['not_publish_pirce', 'calc_out_lecturer_price']}
              myPage={'none'}
              refetch={refetch}/>
        </Space>                
    </CardLayout>
  )
};

export default  ProjectConsult;    